module.exports = __webpack_public_path__ + "img/main_image_banner.096d0226.png";